import React from "react";
import { MdOutlineLightbulb } from "react-icons/md"; // AI/ML Solutions
import { MdOutlineCloudQueue } from "react-icons/md"; // Cloud & Edge Scaling
import { MdOutlineSpeed } from "react-icons/md"; // Optimization
import { FaUsersCog, FaHandsHelping, FaBalanceScale } from "react-icons/fa";

export default function MainSection1() {
  return (
    <div>
      <div className="lg:mt-6 px-4 py-12  mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <div className="flex flex-col justify-center mb-6 lg:justify-center lg:flex-row md:mb-8">
          <h2 className="max-w-4xl mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
            <span className="inline-block mb-1 sm:mb-4">
              Why Choose AeroAegis for R&D Excellence?
            </span>
            <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
          </h2>
        </div>

        <section className="py-4 bg-base-100">
          <div className="container mx-auto px-2">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 place-items-center">
              {[
                {
                  icon: <FaUsersCog />,
                  title: "Expert Teams",
                  description:
                    "Our highly skilled researchers, engineers, and data scientists bring expertise in cutting-edge domains to deliver groundbreaking innovations.",
                },
                {
                  icon: <FaHandsHelping />,
                  title: "Collaborative Ecosystem",
                  description:
                    "We partner with leading academic institutions, research labs, and technology providers to accelerate advancements in emerging fields.",
                },
                {
                  icon: <FaBalanceScale />,
                  title: "Ethical Innovation",
                  description:
                    "We adhere to ethical AI principles and prioritize the safe and responsible development of transformative technologies.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className={`${ index === 2 ? 'md:col-span-2 md:w-full' : '' } card border  h-full lg:w-[300px] lg:col-span-1 border-primary shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2`}
                >
                  <div className="card-body items-center text-center">
                    <div className="text-4xl text-primary mb-4">
                      {item.icon}
                    </div>
                    <h3 className="card-title text-xl mb-2">{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
